import React, { PureComponent } from 'react';
import { Field, reduxForm, change, getFormValues } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { validate, renderMaterialField, renderSelectField, checkValidCountries, popularCountriesArr } from '../../helpers/formHelper';
import { POPULAR_COUNTRIES, FUSE_OPTIONS } from '../../config';
import whatInput from 'what-input';
import Fuse from 'fuse.js';
import _forEach from 'lodash/forEach';

const submit = (values) => {
    //console.log("DISPATCHED FROM BASKET SUMMARY COMPONENT - ", values);
}

class BasketPaxDetails extends PureComponent {

  constructor(props){
    super(props);
    this.state = {
      phoneDropdown:"",
      isPhoneOpen:false,
      nationalitySearch:[],
      nationalitySearchOriginal:[],
      phoneDropdownNumber:-1
    }
    this.documentClickHandler = this.documentClickHandler.bind(this);
    this.documentKeydownHandler = this.documentKeydownHandler.bind(this);
    this.onPhoneClick = this.onPhoneClick.bind(this);
    this.onPhoneChange = this.onPhoneChange.bind(this);
    this.onInputChange = this.onInputChange.bind(this);
    this.fuse = null;
  }

  documentKeydownHandler(e){
    const { isPhoneOpen, phoneDropdownNumber } = this.state;
    const phoneInput = document.querySelectorAll('.filterDropdown.basket ul.phone li');

    if(isPhoneOpen){

      //Increment/Decrement cursor position
      if(e.key === 'ArrowDown' && phoneDropdownNumber < phoneInput.length - 1){
        this.setState({phoneDropdownNumber:phoneDropdownNumber + 1});
      }
      else if(e.key === 'ArrowUp' && phoneDropdownNumber > 0){
        this.setState({phoneDropdownNumber:phoneDropdownNumber - 1});
      }
      else if(e.key === 'Enter'){
        if(phoneInput[phoneDropdownNumber] !== undefined){
          this.onPhoneChange(null, phoneInput[phoneDropdownNumber].dataset.dialingcode,  phoneInput[phoneDropdownNumber].dataset.countrycode, false);
        }
      }
    }
  }

  componentDidUpdate(prevProp, prevState){

    const { phoneDropdownNumber } = this.state;

      if(phoneDropdownNumber !== prevState.phoneDropdownNumber){

        const phoneInputContainer = document.querySelector('.filterDropdown.basket ul.phone');
        const phoneInput = document.querySelectorAll('.filterDropdown.basket ul.phone li');


        for(let i = 0; i < phoneInput.length; i++){
          phoneInput[i].classList.remove('hover');
        }

        //update state
        //this.onPhoneChange(null, phoneInput[phoneDropdownNumber].dataset.countrycode, phoneInput[phoneDropdownNumber].dataset.dialingcode, true);

        if(phoneInput[phoneDropdownNumber].dataset.index !== undefined){

          //hover state
          phoneInput[phoneDropdownNumber].classList.add('hover');

          //scroll container
          phoneInputContainer.scrollTop = phoneInput[phoneDropdownNumber].offsetTop;
        }

       }

       if(this.props.basketType === "product"){
         if(this.props.nationality !== prevProp.nationality){
           this.populateFuse(this.props.nationality);
         }
        }

  }


  componentDidMount(){

    document.body.addEventListener('click', this.documentClickHandler);

    //populate input values
    setTimeout(() => {
      _forEach(document.querySelectorAll('.basket-pax-details input'), item => {
        if(item.value !== "") {
          item.parentElement.parentElement.classList.add('hovered');
        }
      });
    },10);

    //setup custom nationality flags
    this.populateFuse(this.props.nationality);

  }


  populateFuse(nationality){
    this.setState({
      nationalitySearch:nationality,
      nationalitySearchOriginal:nationality
    }, () => {
      this.fuse = new Fuse(nationality, FUSE_OPTIONS);

      //Populate phonePrefix if exist in state
      if(this.props.basketPaxValues && this.props.basketPaxValues.phonePrefix !== ""){
        for(let k=0; k < nationality.length; k++){
          if(nationality[k].iso_country_code === this.props.basketPaxValues.phonePrefix){
            this.setState({phoneDropdown:nationality[k].dialing_code});
          }
        }
      }

    });
  }


  componentWillUnmount(){
    document.body.removeEventListener('click', this.documentClickHandler);
  }



  documentClickHandler(e){

    const { phoneDropdown, nationalitySearchOriginal, nationalitySearch } = this.state;

    try{
      if(whatInput.ask() !== "touch"){
        if(e.target.offsetParent.className !== "filterDropdown basket" && e.target.offsetParent.className !== "phone"){

          this.setState({
            isPhoneOpen:false,
            nationalitySearch:(phoneDropdown === "" || checkValidCountries(nationalitySearchOriginal, phoneDropdown) ) ? nationalitySearchOriginal : nationalitySearch
          }, () => {
            if(checkValidCountries(nationalitySearchOriginal, phoneDropdown)){
            const dividers =  document.querySelectorAll('.dividers');
              for(let i = 0; i < dividers.length; i++){
                dividers[i].classList.remove('hide');
              }
            }
          });

        }
      }
    }catch(e){}
  }



  onPhoneClick(e){
    e.preventDefault();
    this.setState({
      isPhoneOpen:!this.state.isPhoneOpen,
      phoneDropdown:""
    });
  }

  onPhoneChange(e, dialCode, countryCode, isClose = false){
    this.setState({
      phoneDropdown:dialCode,
      isPhoneOpen:isClose
    }, () => {
      this.props.change('phonePrefix', countryCode)
    });
  }

  onInputChange(e){
    const dividers = document.querySelectorAll('.dividers');

    if(e.target.value === ""){
      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.remove('hide');
      }
      this.setState({phoneDropdown:"", nationalitySearch:this.state.nationalitySearchOriginal});
    }else{

      for(let i = 0; i < dividers.length; i++){
        dividers[i].classList.add('hide');
      }
      this.setState({phoneDropdown:e.target.value, nationalitySearch:this.fuse.search(e.target.value)});
    }

  }

  renderPrefixSelectMobile(){
    return(
      <Field name="phonePrefix" component={renderSelectField} class="no-label" classType="phone-prefix" onChange={e => {e.target.classList.add('active')}}>
        <option value="" disabled>Dial Code</option>
        <option value="" disabled>----------</option>
          { popularCountriesArr(this.state.nationalitySearch, POPULAR_COUNTRIES).map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code } disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name} ( ${item.dialing_code} )` : "----------------"}</option>)}
        <option value="" disabled>----------</option>
         { this.state.nationalitySearch.map(item => <option key={item.dialing_code + Math.random()} value={ item.iso_country_code } disabled={item.dialing_code !== "" ? "" : 'disabled' }>{(item.dialing_code !== "") ? `${item.name} ( ${item.dialing_code} )` : "----------------"}</option>)}
      </Field>
    )
  }


  renderPrefixSelect(){

    const { isPhoneOpen, phoneDropdown, nationalitySearch } = this.state;

    return(
      <div className="filterDropdown basket no-margin">
        <div className="row">
          <div className="columns small-12 no-margin">
            <input type="text" placeholder="Dial code" onClick={ e => this.onPhoneClick(e) } onKeyDown={e => this.documentKeydownHandler(e)} onChange={this.onInputChange} value={phoneDropdown} className="filterDropdown-btn phone" />
            <i className={`fa fa-chevron-down phone ${isPhoneOpen ? 'active' : ''}`} aria-hidden="true"></i>
          </div>

           <div className="columns small-12 no-margin phone-container">
            <ul className="phone" style={{display: isPhoneOpen ? 'block':'none' }}>
              <li className="dividers" data-index="0">--------------------</li>
              {
                popularCountriesArr(nationalitySearch, POPULAR_COUNTRIES).map((item, index) => {
                  return (
                    <li
                      data-index={index + 1}
                      data-countrycode={item.iso_country_code}
                      data-dialingcode={item.dialing_code}
                      onClick={e => this.onPhoneChange(e, item.dialing_code, item.iso_country_code)}
                      key={item.dialing_code + Math.random()}>
                       <img alt={`${item.name} flag`} src={`/images/flags/${item.iso_country_code.toLowerCase()}.png` } /> {item.name} ( {item.dialing_code} )
                    </li>
                  )
                })
              }
              <li className="dividers" data-index={POPULAR_COUNTRIES.length + 1}>--------------------</li>
              {
                nationalitySearch.map((item, index) => {
                  return (
                    <li
                      data-index={(POPULAR_COUNTRIES.length + 2) + index}
                      data-countrycode={item.iso_country_code}
                      data-dialingcode={item.dialing_code}
                      onClick={e => this.onPhoneChange(e, item.dialing_code, item.iso_country_code)}
                      key={item.dialing_code + Math.random()}>
                      <img alt={`${item.name} flag`} src={`/images/flags/${item.iso_country_code.toLowerCase()}.png` } />  {item.name} ( {item.dialing_code} )
                    </li>
                  )
                })
              }

            </ul>
          </div>

        </div>
      </div>
    )
  }

  render(){
    const { handleSubmit } = this.props;

    return (
      <div className="basket-pax-details">
        <div className="row">
          <div className="column small-12">
            <h5 className="busabout-h5">
              Enter your details
            </h5>
            <p>Before you can continue we need some details to hold the places for you</p>
          </div>
        </div>
        <form
          onSubmit={handleSubmit}>
          <div className="row">
            <div className="column small-12 medium-6 col-left-mod">
              <Field name="firstName" fieldId="firstName" component={renderMaterialField} type="text" label="First name *" />
            </div>

            <div className="column small-12 medium-6 col-right-mod">
              <Field name="surname" fieldId="surname" component={renderMaterialField} type="text"  label="Last name *" />
            </div>
          </div>

          <div className="row">
            <div className="column small-12 medium-6 col-left-mod no-margin-bottom">
              <Field name="email" fieldId="email" component={renderMaterialField} type="email"  label="Email address *" />
            </div>

            <div className="column small-12 medium-6 col-right-mod no-margin-bottom">
              <div className="column small-5 large-4 no-padding">
                  {  (window.innerWidth < 640) ?  this.renderPrefixSelectMobile() : this.renderPrefixSelect() }
              </div>
              <div className="column small-7 large-8 no-padding">
                <Field name="phone" fieldId="phone" component={renderMaterialField} type="text" label="Contact number" />
              </div>
            </div>
          </div>

        </form>
      </div>
    )
  }

}


BasketPaxDetails = reduxForm({
  form: 'BasketPax',
  validate,
  onSubmit:submit,
  destroyOnUnmount: false
})(BasketPaxDetails);

function mapStateToProps(state){
  return {
    basketPaxValues:getFormValues('BasketPax')(state),
    nationality:state.nationality
  }
}

function mapDispatchToProps(dispatch){
  return bindActionCreators({
    change
  }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(BasketPaxDetails);



// WEBPACK FOOTER //
// ./src/components/basket/basketPaxDetails.js